import { Injectable } from "@angular/core";
import { Action } from "../model/action";
import { Organization } from "../model/organization";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { HttpClientService } from "../../../shared/service/http/http-client.service";
import { CookiesService } from "../../../shared/service/cookies/cookies.service";

@Injectable()
export class OrganizationMasterService {
  http: HttpClientService;
  cookie: CookiesService;
  objAction: Action;
  data: Organization;
  constructor(http: HttpClientService, cook: CookiesService) {
    this.http = http;
    this.cookie = cook;
    this.objAction = new Action(this.http, this.cookie);
  }

  saveOrganization(): Observable<Organization> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Organization/CreateOrganization";
    return this.objAction.save();
  }
  updateOrganization(): Observable<Organization> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Organization/updateOrganization";
    return this.objAction.update();
  }
  getOrganization(): Observable<Organization[]> {
    this.objAction.path = "api/Organization/GetOrganization";
    return this.objAction.get();
  }
  deleteOrganization(org: Organization): Observable<Organization> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path =
      "api/Organization/DeleteOrganization?strOrganizationId=" + org.OrgId;
    return this.objAction.delete();
  }

  getState(): Observable<any[]> {
    this.objAction.path = "api/Common/GetCountry";
    return this.objAction.get();
  }

  getCountry(): Observable<any> {
    this.objAction.path = "api/Common/GetCountry";
    return this.objAction.get();
  }

  getTimezones(id: number): Observable<any> {
    this.objAction.path = "api/Common/GetTimezone?data=" + id;
    return this.objAction.get();
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/services/organization-master.service.ts